<template>
    <div class="tCenteredArea_Easy">
        <div id="tFollows_Easy">

            <div v-if="follows.length == 0" class="noFollows">
                <span class="material-symbols-outlined" translate="no">
                    sentiment_dissatisfied
                </span>
                <h3 class="noFollowsText" v-html="$t('general_text.noFollows')"></h3>
            </div>


            <div v-for="follow in follows" :key="follow.id" class="follows">
                <div class="follows-inner">
                    <img :src="$utils.getAvatar(follow.avatar)" class="avatar">
                    <div class="unFollowDiv" @click="unFollow(follow)"><i class="pi pi-times"></i></div>
                </div>
                <span class="EasyStatus" :class="'EasyStatus_' + follow.online"></span>
                <div class="secondaryFollows">
                    <div class="nickname">
                        <div class="nickname_class">{{ follow.nickname }}</div>
                        <span class="age_gender" :class="$utils.getClass(follow.gender)"
                            v-html="$utils.getAgeSex(follow)"></span>
                    </div>
                </div>
                <div class="followsButton">
                    <Button :label="$t('buttons.message')" icon="pi pi-send" severity="secondary" size="small" raise
                        @click="sendMesssage(follow)" />
                    <Button :label="$t('buttons.gift')" icon="pi pi-gift" severity="secondary" size="small"
                        @click="sendGift(follow)" />
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: 'Follows',
    props: ['follows'],
    data() {
        return {
        };
    },
    methods: {
        sendMesssage(user) {
  
            this.$emit('selectMenu', { user: { user_id: user.id || user._id, nickname: user.nickname, avatar: user.avatar }, action: 'message' });
        },
        sendGift(user) {
            this.$emit('selectMenu', { user: { user_id: user.id || user._id, nickname: user.nickname, avatar: user.avatar }, action: 'gift' });
        },
        unFollow(user) {
            this.$socket.emit('follow', { target: user.id || user._id, action: 'unfollow' });
        }
    }
};  
</script>
<style scoped>
#tFollows_Easy {
    --p-button-secondary-background: var(--p-surface-200) !important;
    --p-button-secondary-hover-background: var(--p-surface-300) !important;
    max-width: 1200px;
    margin: auto;
}



#tFollows_Easy {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

#tFollows_Easy .avatar {
    width: 160px;
    height: 160px;
    border-radius: 8px;
    margin: auto;
    display: block;
    object-fit: cover;
}

.follows {
    background-color: var(--p-neutral-100);
    padding: 10px;
    border-radius: 10px;
    position: relative;
}

.followsButton {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}

.secondaryFollows {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
}

.nickname {
    position: relative;
    padding: 4px 8px;
    width: 100%;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--p-neutral-800)
}

.age_gender {
    top: 8px;
}

span.age_gender {
    right: 0;
}

.nickname_class {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 130px;
}

.unFollowDiv {
    position: absolute;
    height: 60px;
    width: 60px;
    top: 55px;
    left: 60px;
    display: none;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #8080807d;
    color: white;
    cursor: pointer;
}

.unFollowDiv i {
    font-size: 24px;
}

.follows-inner:hover .unFollowDiv {
    display: flex;
}

.noFollowsText {
    font-size: 24px;
    color: var(--p-neutral-500);
    max-width: 400px;
    padding: 50px 0px;
    text-align: center;
    margin: auto;
    padding-top: 20px;
}
</style>